import React from "react";
import Chips from "../../Chips";
import Tooltip from "../../Tooltip";

//Module imports
import nth0 from "@/modules/nth0";
import { isIPhone } from "@/modules/iOSDetection";
import {mouseOver, mouseLeave} from "@/modules/mouseInteractions";
import nary from "@/modules/nary";
import { getWinClassName, twentyFourDReds } from "@/modules/commonMobile";
import zeroFill from "@/modules/zeroFill";

//Type import
import { IGameTableType } from "@/types/GlobalTypes";

import "./index.scss";

//New prototype Components
import SlBet from "../../SlBet";
import MultibetGenerator from "../../MultibetGenerator";

//24D
export default class P6 extends React.PureComponent<IGameTableType> {
	state = {activeHover: ""};

	render() {
		const { langdata } = this.props;

		const singleGame = this.props.maximised;
		
		const Reds = twentyFourDReds;
		const win = this.props.win ? Number(this.props.win) : null;
		const winStr = win ? zeroFill(win, 2) : null;

		const pcodeProp = {pcode: this.props.pcode};

		const commonBetProps = {
			pcode: this.props.pcode,
			chipBase: this.props.chipBase,
			mobile: this.props.mobile,
			bets: this.props.bets,
			insertBet: this.props.insertBet,
			betOutOfBounds: this.props.betOutOfBounds,
			langStr: this.props.langdata.language_code
		};

		const commonChipProps = {
			mobile: this.props.mobile,
			chipBase: this.props.chipBase,
			bets: this.props.bets,
			betOutOfBounds: this.props.betOutOfBounds
		};

		const commonTooltipProps = {
			langStr: langdata.language_code
		};

		const commonMultiBetProps = {
			...commonBetProps,

			mouseOver: !isIPhone() ? mouseOver.bind(this) : null,
			mouseLeave: !isIPhone() ? mouseLeave.bind(this) : null,
		};

		return (
		this.props.portrait ? (
			<div className="sl-table p6">
				<div className="row">
					<SlBet
						classes="sl-bet col-xs-6 sl-green-old"
						bet="Small"
						group="n50"

						winStatement={win < 12 && win > 0}

						betLabel={this.props.langdata["txt_small"]}
						betType="1:0.95"

						noTooltip={true}

						{...commonBetProps}
					/>

					{/* 
					<div className={"sl-bet col-xs-6 sl-green-old" + ((win < 12 && win > 0) ? " sl-yellow-alternating" : "")}
						{...{
							bet: "Small",
							group: "n50",
							...pcodeProp
						}}
						onClick={this.props.insertBet}>

						{this.props.langdata["txt_small"]}
						<div className="bet-type">1:0.95</div>
						<Chips {...commonChipProps} betKey="Small+n50" />
					</div>
					*/}

					<div className={"sl-bet col-xs-6 sl-green-old" + ((win >= 13 && win <= 24) ? " sl-yellow-alternating" : "")}
						{...{
							bet: "Big",
							group: "n50",
							...pcodeProp
						}}
						onClick={this.props.insertBet}>

						{this.props.langdata["txt_big"]}
						<div className="bet-type">1:0.95</div>
						<Chips {...commonChipProps} betKey="Big+n50" />
					</div>
				</div>
					
				<div className="row">
					<div className={"sl-bet col-xs-6 sl-green-old" + ((win % 2) ? " sl-yellow-alternating" : "")}
						{...{
							bet: "Odd",
							group: "n50",
							...pcodeProp
						}}
						onClick={this.props.insertBet}>

						{this.props.langdata["txt_odd"]}
						<div className="bet-type">1:0.95</div>
						<Chips {...commonChipProps} betKey="Odd+n50" />
					</div>

					<div className={"sl-bet col-xs-6 sl-green-old" + (!(win % 2) && (win > 0) ? " sl-yellow-alternating" : "")}
						{...{
							bet: "Even",
							group: "n50",
							...pcodeProp
						}}
						onClick={this.props.insertBet}>

						{this.props.langdata["txt_even"]}
						<div className="bet-type">1:0.95</div>
						<Chips {...commonChipProps} betKey="Even+n50" />
					</div>
				</div>
					
				<div className="row">
					<div className={"sl-bet col-xs-6 sl-red-lighten" + ((Reds.indexOf(Number(win)) >= 0 ? " sl-yellow-alternating" : ""))}
						{...{
							bet: "Red",
							group: "n50",
							...pcodeProp
						}}
						onClick={this.props.insertBet}>

						{this.props.langdata["txt_red"]}
						<div className="bet-type">1:0.95</div>
						<Chips {...commonChipProps} betKey="Red+n50" />
					</div>
					<div className={"sl-bet col-xs-6 sl-black-lighten" + ((Reds.indexOf(Number(win)) < 0 && win > 0) ? " sl-yellow-alternating" : "")}
						{...{
							bet: "Black",
							group: "n50",
							...pcodeProp
						}}
						onClick={this.props.insertBet}>
						{this.props.langdata["txt_black"]}
						<div className="bet-type">1:0.95</div>
						<Chips {...commonChipProps} betKey="Black+n50" />
					</div>
				</div>
					
				<div className="row">
					<div className="col-xs-2">&nbsp;</div>
					{
						nary(4).reverse().map((num, idx) =>
							<div key={"p6_row_" + idx}
								className={"sl-bet col-xs-2 sl-green-old" + (((win - 1) % 4 === 3 - idx) && win !== null ? " sl-yellow-alternating" : "")}

								{...{
									bet: nth0(num - 1) + " Row",
									pcode: this.props.pcode,
									group: "n6"
								}}

								onClick={this.props.insertBet}>

								<div>Row {num}</div>
								<div className="bet-type">1:2.84</div>
								<Chips {...commonChipProps} betKey={nth0(num - 1) + " Row+n6"} />
							</div>
						)
					}
				</div>
				
				<div className="row">
					<div className="col-xs-2">
					{
						nary(5).map((item, idx) => {
								const first = nth0(idx),
									second = nth0(item),

									bet = `${first} Column,${second} Column`,
									betGroup = "n8",
									betKey = `${bet}+${betGroup}`;

								return <div key={"p6_n8_" + idx} className={"sl-bet col-xs-12 sl-green-old taller" + ((win >= idx * 4 + 1 && win <= (idx + 2) * 4) ? " sl-yellow-alternating" : "")}>
									<div dangerouslySetInnerHTML={{__html: this.props.langdata[`txt_${first}_${second}_line`]}}></div>
									<div className="bet-type">1:1.75</div>
									<Chips {...commonChipProps} betKey={betKey} />
									<Tooltip {...commonTooltipProps} bet={this.props.bets[betKey]} />
									<div className="sl-hover-hidden"

										{...{
											bet: bet,
											pcode: this.props.pcode,
											group: betGroup
										}}

										onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
								</div>;
							}
						)
					}
					</div>

					<div className="col-xs-10">
					{
						["01,02,03,04", "05,06,07,08", "09,10,11,12", "13,14,15,16", "17,18,19,20", "21,22,23,24"].map((group, groupIdx) => {
							const nth = nth0(groupIdx);
							return [
								...group.split(",").reverse().map(num =>
									<div key={group + groupIdx + num} className={"sl-bet col-20p " + (Reds.indexOf(Number(num)) >= 0 ? "sl-red-lighten" : "sl-black-lighten")
										+ ((+num === win && win !== null) ? " sl-yellow-alternating" : "")}

										{...{
											bet: num,
											group: "n",
											...pcodeProp
										}}

										onClick={this.props.insertBet}>
										{num}
										<div className="bet-type">1:22</div>
										<Chips {...commonChipProps} betKey={num + "+n"} />
									</div>
								),
								<div key={group + groupIdx + "_1"} className={"sl-bet col-20p sl-green-old" + ((group.indexOf(winStr) >= 0 && win !== null) ? " sl-yellow-alternating" : "")}
									{...{
										bet: nth + " Column",
										group: "n4",
										...pcodeProp 
									}}

									onClick={this.props.insertBet}>
									Line {groupIdx + 1}
									<div className="bet-type">1:4.75</div>
									<Chips {...commonChipProps} betKey={nth + " Column+n4"} />
								</div>
							];
						})
					}
					</div>
				</div>
				
				<div className="row">
					<div className="col-xs-2"></div>
					<div className={"sl-bet col-xs-4 sl-green-old" + ((win % 4 === 3 || win % 4 === 0) && win !== null ? " sl-yellow-alternating" : "")}
						{...{
							bet: "3rd Row,4th Row",
							group: "n12",
							...pcodeProp
						}}
						onClick={this.props.insertBet}>

						Row 3 &amp; 4
						<div className="bet-type">1:0.95</div>
						<Chips {...commonChipProps} betKey={"3rd Row,4th Row+n12"} />
					</div>
					<div className={"sl-bet col-xs-4 sl-green-old" + ((win % 4 === 1 || win % 4 === 2) ? " sl-yellow-alternating" : "")}
						{...{
							bet: "1st Row,2nd Row",
							group: "n12",
							...pcodeProp
						}}
						// bet={"1st Row,2nd Row"} pcode={this.props.pcode} group="n12" 
						onClick={this.props.insertBet}>
						Row 1 &amp; 2
						<div className="bet-type">1:0.95</div>
						<Chips {...commonChipProps} betKey={"1st Row,2nd Row+n12"} />
					</div>
				</div>
					
					
				{/*Mobile portrait multibet starts here*/}
				{
					[["01,05", "02,06", "03,07", "04,08"],
						["05,09", "06,10", "07,11", "08,12"],
						["09,13", "10,14", "11,15", "12,16"],
						["13,17", "14,18", "15,19", "16,20"],
						["17,21", "18,22", "19,23", "20,24"]].map((row, rowIdx) => 
							row.reverse().map((groupComma, groupIdx) => {
								const firstPercent = 16.66;
								const leftSpace = 16.66;

								return <div key={"p12_" + groupComma + "_n2"}
									className={"sl-bet hidden col-xs-2"}
									style={{position: "absolute",
											left: "calc(" + firstPercent + "% + " + (groupIdx * leftSpace) + "%)",
											top: "calc(43% + " + (rowIdx * 6) + "vh)",
											// background: "rgba(0,0,0,0.5)",
											border: "none",
											height: "3vh"}}>
									<Chips between={true} {...commonChipProps} betKey={groupComma + "+n2"} />
									<Tooltip {...commonTooltipProps} bet={this.props.bets[groupComma + "+n2"]} />
									<div className="sl-hover-hidden"
										{...{
											bet: groupComma,
											group: "n2",
											...pcodeProp
										}}
										// bet={groupComma} pcode={this.props.pcode} group="n2"
										onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
								</div>;
							})
						)
				}

				{
					[["01,02", "02,03", "03,04"],
						["05,06", "06,07", "07,08"],
						["09,10", "10,11", "11,12"],
						["13,14", "14,15", "15,16"],
						["17,18", "18,19", "19,20"],
						["21,22", "22,23", "23,24"]].map((row, rowIdx) => 
							row.reverse().map((groupComma, groupIdx) => {
								const firstPercent = 29;
								const leftSpace = 16.66;

								return <div key={"p12_" + groupComma + "_n2"}
										className={"sl-bet hidden col-xs-1"}
										style={{position: "absolute",
											left: "calc(" + firstPercent + "% + " + (groupIdx * leftSpace) + "%)",
											top: "calc(38% + " + (rowIdx * 6) + "vh)",
											// background: "rgba(255,255,0,0.5)",
											border: "none",
											height: "3vh"}}>
									<Chips between={true} {...commonChipProps} betKey={groupComma + "+n2"} />
									<Tooltip {...commonTooltipProps} bet={this.props.bets[groupComma + "+n2"]} />
									<div className="sl-hover-hidden"
										{...{
											bet: groupComma,
											group: "n2",
											...pcodeProp
										}}
										// bet={groupComma} pcode={this.props.pcode} group="n2"
										onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
								</div>;
							})
						)
				}

				{
					[["01,02,05,06", "02,03,06,07", "03,04,07,08"],
						["05,06,09,10", "06,07,10,11", "07,08,11,12"],
						["09,10,13,14", "10,11,14,15", "11,12,15,16"],
						["13,14,17,18", "14,15,18,19", "15,16,19,20"],
						["17,18,21,22", "18,19,22,23", "19,20,23,24"]].map((row, rowIdx) => 
						row.reverse().map((groupComma, groupIdx) => {
							const firstPercent = 29;
							const leftSpace = 16.66;

							return <div key={"p12_" + groupComma + "_n4"}
								className={"sl-bet hidden col-xs-1"}
								style={{position: "absolute",
										left: "calc(" + firstPercent + "% + " + (groupIdx * leftSpace) + "%)",
										top: "calc(43% + " + (rowIdx * 6) + "vh)",
										// background: "rgba(0,128,0,0.5)",
										border: "none",
										height: "3vh"}}>
								<Chips between={true} {...commonChipProps} betKey={groupComma + "+n4"} />
								<Tooltip {...commonTooltipProps} bet={this.props.bets[groupComma + "+n4"]} />
								<div className="sl-hover-hidden"
										{...{
											bet: groupComma,
											group: "n4",
											...pcodeProp
										}}
										//bet={groupComma} pcode={this.props.pcode} group="n4"
										onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
							</div>;
						})
					)
				}
			</div>
		
		) : (
			<div className="sl-table p6-table">
				<div className="sides">
					<div className={"sl-bet sl-green-old" + ((win < 12 && win > 0) ? " sl-yellow-alternating" : "")}>
						{this.props.langdata["txt_small"]}
						{/*  singleGame ? <span>Small</span> : <span>SMALL</span>  */}
						{ singleGame && <div className="bet-type">1:0.95</div> }

						<Chips {...commonChipProps} betKey="Small+n50" />

						<Tooltip {...commonTooltipProps} bet={this.props.bets["Small+n50"]} />
						<div className="sl-hover-hidden"
							{...{
								bet: "Small",
								group: "n50",
								...pcodeProp
							}}
							// bet="Small" pcode={this.props.pcode} group="n50"
							onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
					</div>
						
					<div className={"sl-bet sl-green-old" + ((win % 2) ? " sl-yellow-alternating" : "")}>
						{this.props.langdata["txt_odd"]}
						{/*  singleGame ? <span>Odd</span> : <span>ODD</span>  */}
						{ singleGame && <div className="bet-type">1:0.95</div> }
						<Chips {...commonChipProps} betKey="Odd+n50" />
						<Tooltip {...commonTooltipProps} bet={this.props.bets["Odd+n50"]} />
						<div className="sl-hover-hidden"
							{...{
								bet: "Odd",
								group: "n50",
								...pcodeProp
							}}
							// bet="Odd" pcode={this.props.pcode} group="n50"
							onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
					</div>
						
					<div className={"sl-bet sl-green-old" + ((Reds.indexOf(Number(win)) >= 0 ? " sl-yellow-alternating" : ""))}>
						<div className="p6-diamond sl-red-lighten"></div>
						{ singleGame && <div className="bet-type">1:0.95</div> }
						<Chips {...commonChipProps} betKey="Red+n50" />
						<Tooltip {...commonTooltipProps} bet={this.props.bets["Red+n50"]} />
						<div className="sl-hover-hidden"
							{...{
								bet: "Red",
								group: "n50",
								...pcodeProp
							}}
							//bet="Red" pcode={this.props.pcode} group="n50"
							onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
					</div>
				</div>
				<div className="main-box-bet">
					<div className="detail-bet left-column">
						{
							nary(4).map((num, numIdx) => {
								const nth = nth0(numIdx);

								return (
									<div key={"db lc " + num}
										className={"sl-bet sl-green-old" + (getWinClassName(win && (win % 4 === num % 4)))}>
										<div dangerouslySetInnerHTML={{__html:
												this.props.langdata["txt_" + nth + "_row"]}
											} />

										{ singleGame && <div className="bet-type">1:2.84</div> }
										
										<Chips {...commonChipProps} 
											betKey={nth + " Row+n6"} />

										<Tooltip {...commonTooltipProps} bet={this.props.bets[nth + " Row+n6"]} />

										<div className="sl-hover-hidden"
										{...{
											bet: nth + " Row",
											group: "n6",
											...pcodeProp
										}}
											// bet="1st Row" pcode={this.props.pcode} group="n6"
											onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
									</div>
								);
							})
						}

						{/* 
						<div className={"sl-bet sl-green-old" + ((win % 4 === 1) ? " sl-yellow-alternating" : "")}>
							<div dangerouslySetInnerHTML={{__html: this.props.langdata["txt_1st_row"]}}></div>
							{ singleGame ? <div className="bet-type">1:2.84</div> : null }
							<Chips {...commonChipProps} betKey="1st Row+n6" />
							<Tooltip {...commonTooltipProps} bet={this.props.bets["1st Row+n6"]} />
							<div className="sl-hover-hidden" bet="1st Row" pcode={this.props.pcode} group="n6"
								onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
						</div>
						
						<div className={"sl-bet sl-green-old" + ((win % 4 === 2) ? " sl-yellow-alternating" : "")}>
							<div dangerouslySetInnerHTML={{__html: this.props.langdata["txt_2nd_row"]}}></div>
							{ singleGame ? <div className="bet-type">1:2.84</div> : null }
							<Chips {...commonChipProps} betKey="2nd Row+n6" />
							<Tooltip {...commonTooltipProps} bet={this.props.bets["2nd Row+n6"]} />
							<div className="sl-hover-hidden" bet="2nd Row" pcode={this.props.pcode} group="n6"
								onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
						</div>
						
						<div className={"sl-bet sl-green-old" + ((win % 4 === 3) ? " sl-yellow-alternating" : "")}>
							<div dangerouslySetInnerHTML={{__html: this.props.langdata["txt_3rd_row"]}}></div>
							{ singleGame ? <div className="bet-type">1:2.84</div> : null }
							<Chips {...commonChipProps} betKey="3rd Row+n6" />
							<Tooltip {...commonTooltipProps} bet={this.props.bets["3rd Row+n6"]} />
							<div className="sl-hover-hidden" bet="3rd Row" pcode={this.props.pcode} group="n6"
								onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
						</div>
						
						<div className={"sl-bet sl-green-old" + ((win % 4 === 0 && win !== "") ? " sl-yellow-alternating" : "")}>
							<div dangerouslySetInnerHTML={{__html: this.props.langdata["txt_4th_row"]}}></div>
							{ singleGame ? <div className="bet-type">1:2.84</div> : null }
							<Chips {...commonChipProps} betKey="4th Row+n6" />
							<Tooltip {...commonTooltipProps} bet={this.props.bets["4th Row+n6"]} />
							<div className="sl-hover-hidden" bet="4th Row" pcode={this.props.pcode} group="n6"
								onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
						</div>
						*/}
					</div>
					
					{
						//Maps the table according to the colour
						"rbrbrb".split("").map((colour, colIdx) => {
							const nth = nth0(colIdx);
							return (
								<div key={colIdx + "thLine"}
									className="detail-bet">

									<div className={"sl-bet top-row sl-green-old" + ((colIdx * 4 + 1 <= Number(win) && Number(win) <= (colIdx + 1) * 4 && win !== null) ? " sl-yellow-alternating" : "")}>
										<div dangerouslySetInnerHTML={{__html: this.props.langdata["txt_" + nth + "_line"]}}></div>
										{/*  singleGame ? <span>{nth} LINE</span> : <span>{nth} LINE</span>  */}
										{ singleGame && <div className="bet-type">1:4.75</div> }
										<Chips {...commonChipProps} betKey={nth + " Column+n4"} />
										<Tooltip {...commonTooltipProps} bet={this.props.bets[nth + " Column+n4"]} />
										<div className="sl-hover-hidden"

											{...{
												bet: nth + " Column",
												group: "n4",
												...pcodeProp
											}}
											// bet={nth + " Column"} pcode={this.props.pcode} group="n4"

											onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
									</div>
									{ 
										nary(4).map(rowNum => {
											const num = Number(rowNum) + colIdx * 4;
											const betKey = ((num < 10) ? "0" : "") + num;
											let styles = (colour === "r" ? "sl-red-lighten " : "sl-black-lighten ");
											const activeHover = this.state.activeHover;

											if (
												(activeHover.indexOf(betKey) >= 0) ||
												(activeHover.length === 7 && (rowNum + "") === activeHover[0]) || //Row hover
												(activeHover.length === 10 && colIdx + 1 === Number(activeHover[0])) || //Column hover
												(activeHover.length === 15 && ((rowNum + "") === activeHover[0] || (rowNum + "") === activeHover[8])) || //Double row hover
												(activeHover.length === 21 && ((colIdx + 1) === Number(activeHover[0]) || (colIdx + 1) === Number(activeHover[11]))) || //Double column hover
												(activeHover === "Odd" && num % 2) ||
												(activeHover === "Even" && !(num % 2)) ||
												(activeHover === "Red" && colour === "r") ||
												(activeHover === "Black" && colour === "b") ||
												(activeHover === "Small" && num <= 12) ||
												(activeHover === "Big" && num >= 13))
												styles = " sl-bet-hover";

											if (win === +betKey)
												styles += " sl-yellow-alternating";

											return (
												<div key={"p6_" + colour + "_" + colIdx + "_" + betKey}
														className={"sl-bet " + styles}
													{...{
														bet: betKey,
														group: "n",
														...pcodeProp
													}}
														onClick={this.props.insertBet}>
													<div>{num}</div>
													{ singleGame && <div className="bet-type">1:22</div> }
													<Chips {...commonChipProps} betKey={betKey + "+n"} />
													<Tooltip {...commonTooltipProps} bet={this.props.bets[betKey + "+n"]} />
												</div>);
										})
									}
								</div>
							);
						})
					}
					<div className="detail-bet two-rows">
						<div className={"sl-bet right-column sl-green-old" + ((win % 4 === 1 || win % 4 === 2) ? " sl-yellow-alternating" : "")}>
							<span dangerouslySetInnerHTML={{__html: this.props.langdata["txt_1st_line_2nd_line"]}}></span>
							{ singleGame && <div className="bet-type">1:0.95</div> }
							<Chips {...commonChipProps} betKey="1st Row,2nd Row+n12" />
							<Tooltip {...commonTooltipProps} bet={this.props.bets["1st Row,2nd Row+n12"]} />
							<div className="sl-hover-hidden"
							{...{
								bet: "1st Row,2nd Row",
								group: "n12",
								...pcodeProp
							}}
								//bet={"1st Row,2nd Row"} pcode={this.props.pcode} group="n12"

								onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
						</div>
						
						<div className={"sl-bet right-column sl-green-old" + ((win % 4 === 3 || win % 4 === 0) && win !== null ? " sl-yellow-alternating" : "")}>
							<span dangerouslySetInnerHTML={{__html: this.props.langdata["txt_3rd_line_4th_line"]}}></span>

							{ singleGame && <div className="bet-type">1:0.95</div> }
							<Chips {...commonChipProps} betKey="3rd Row,4th Row+n12" />
							<Tooltip {...commonTooltipProps} bet={this.props.bets["3rd Row,4th Row+n12"]} />
							<div className="sl-hover-hidden"
							{...{
								bet: "3rd Row,4th Row",
								group: "n12",
								...pcodeProp
							}}
								// bet={"3rd Row,4th Row"} pcode={this.props.pcode} group="n12"

								onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
						</div>
					</div>
				</div>
				<div className="sides">
					<div className={"sl-bet sl-green-old" + ((win >= 13 && win <= 24) ? " sl-yellow-alternating" : "")}>
						{this.props.langdata["txt_big"]}
						{/*  singleGame ? <span>Big</span> : <span>BIG</span>  */}
						{ singleGame && <div className="bet-type">1:0.95</div> }
						<Chips {...commonChipProps} betKey="Big+n50" />
						<Tooltip {...commonTooltipProps} bet={this.props.bets["Big+n50"]} />
						<div className="sl-hover-hidden"
							{...{
								bet: "Big",
								group: "n50",
								...pcodeProp
							}}
							// bet="Big" pcode={this.props.pcode} group="n50"
							onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
					</div>
					<div className={"sl-bet sl-green-old" + (!(win % 2) && (win > 0) ? " sl-yellow-alternating" : "")}>
						{this.props.langdata["txt_even"]}
						{/*  singleGame ? <span>Even</span> : <span>EVEN</span>  */}
						{ singleGame && <div className="bet-type">1:0.95</div> }
						<Chips {...commonChipProps} betKey="Even+n50" />
						<Tooltip {...commonTooltipProps} bet={this.props.bets["Even+n50"]} />
						<div className="sl-hover-hidden"
							{...{
								bet: "Even",
								group: "n50",
								...pcodeProp
							}}
							//bet="Even" pcode={this.props.pcode} group="n50"
							onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
					</div>
					<div className={"sl-bet sl-green-old" + ((Reds.indexOf(Number(win)) < 0 && win > 0) ? " sl-yellow-alternating" : "")}>
						<div className="p6-diamond sl-black-lighten"></div>
						{ singleGame && <div className="bet-type">1:0.95</div> }
						<Chips {...commonChipProps} betKey="Black+n50" />
						<Tooltip {...commonTooltipProps} bet={this.props.bets["Black+n50"]} />
						<div className="sl-hover-hidden" 
							{...{
								bet: "Black",
								group: "n50",
								...pcodeProp
							}}
							// bet="Black" pcode={this.props.pcode} group="n50"
							onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
					</div>
				</div>
									
				<div className="bottomPart">
					{
						nary(5).map((num, numIdx) => {
							const betKey = `${nth0(numIdx)} Column,${nth0(num)} Column`;

							return (
								<div key={"bP " + numIdx}
									className={"sl-bet sl-green-old" +
									(getWinClassName(win >= (1 + numIdx * 4) && win <= (8 + numIdx * 4)))
									}>
									
									<div dangerouslySetInnerHTML={{__html:
										//"txt_1st_2nd_line"
										this.props.langdata[`txt_${nth0(numIdx)}_${nth0(num)}_line`]
									}}></div>

									{ singleGame && <div className="bet-type">1:1.75</div> }
								
									<Chips {...commonChipProps} betKey={betKey + "+n8"} />
								
									<Tooltip {...commonTooltipProps} bet={this.props.bets[betKey + "+n8"]} />
								
									<div className="sl-hover-hidden"
									{...{
										bet: betKey, // "1st Column,2nd Column"
										group: "n8",
										...pcodeProp
									}}
								
										onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
								</div>
							);
						})
					}

					{/* 
					<div className={"sl-bet sl-green-old" + ((win >= 1 && win <= 8) ? " sl-yellow-alternating" : "")}>
						<div dangerouslySetInnerHTML={{__html: this.props.langdata["txt_1st_2nd_line"]}}></div>

						{ singleGame ? <div className="bet-type">1:1.75</div> : null }
						<Chips {...commonChipProps} betKey="1st Column,2nd Column+n8" />
						<Tooltip {...commonTooltipProps} bet={this.props.bets["1st Column,2nd Column+n8"]} />
						<div className="sl-hover-hidden" bet="1st Column,2nd Column" pcode={this.props.pcode} group="n8"
							onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
					</div>
					<div className={"sl-bet sl-green-old" + ((win >= 5 && win <= 12) ? " sl-yellow-alternating" : "")}>
						<div dangerouslySetInnerHTML={{__html: this.props.langdata["txt_2nd_3rd_line"]}}></div>

						{ singleGame ? <div className="bet-type">1:1.75</div> : null }
						<Chips {...commonChipProps} betKey="2nd Column,3rd Column+n8" />
						<Tooltip {...commonTooltipProps} bet={this.props.bets["2nd Column,3rd Column+n8"]} />
						<div className="sl-hover-hidden" bet="2nd Column,3rd Column" pcode={this.props.pcode} group="n8"
							onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
					</div>
					<div className={"sl-bet sl-green-old" + ((win >= 9 && win <= 16) ? " sl-yellow-alternating" : "")}>
						<div dangerouslySetInnerHTML={{__html: this.props.langdata["txt_3rd_4th_line"]}}></div>

						{ singleGame ? <div className="bet-type">1:1.75</div> : null }
						<Chips {...commonChipProps} betKey="3rd Column,4th Column+n8" />
						<Tooltip {...commonTooltipProps} bet={this.props.bets["3rd Column,4th Column+n8"]} />
						<div className="sl-hover-hidden" bet="3rd Column,4th Column" pcode={this.props.pcode} group="n8"
							onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
					</div>
					<div className={"sl-bet sl-green-old" + ((win >= 13 && win <= 20) ? " sl-yellow-alternating" : "")}>
						<div dangerouslySetInnerHTML={{__html: this.props.langdata["txt_4th_5th_line"]}}></div>

						{ singleGame ? <div className="bet-type">1:1.75</div> : null }
						<Chips {...commonChipProps} betKey="4th Column,5th Column+n8" />
						<Tooltip {...commonTooltipProps} bet={this.props.bets["4th Column,5th Column+n8"]} />
						<div className="sl-hover-hidden" bet="4th Column,5th Column" pcode={this.props.pcode} group="n8"
							onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
					</div>
					<div className={"sl-bet sl-green-old" + ((win >= 17 && win <= 24) ? " sl-yellow-alternating" : "")}>
						<div dangerouslySetInnerHTML={{__html: this.props.langdata["txt_5th_6th_line"]}}></div>

						{ singleGame ? <div className="bet-type">1:1.75</div> : null }
						<Chips {...commonChipProps} betKey="5th Column,6th Column+n8" />
						<Tooltip {...commonTooltipProps} bet={this.props.bets["5th Column,6th Column+n8"]} />
						<div className="sl-hover-hidden" bet="5th Column,6th Column" pcode={this.props.pcode} group="n8"
							onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
					</div>
					*/}
				</div>
						
				{/*Multibet starts here*/}
				{
					//Old giant array
					//[
					//["01,05", "05,09", "09,13", "13,17", "17,21"],
					//["02,06", "06,10", "10,14", "14,18", "18,22"],
					//["03,07", "07,11", "11,15", "15,19", "19,23"],
					//["04,08", "08,12", "12,16", "16,20", "20,24"]
					//]

					//Todo: Reduce this into a multibet generator component
					//nary(4).map(row =>
					//	nary(5).map(colNum =>
					//		zeroFill((colNum - 1) * 4 + row, 2) +
					//		"," +
					//		zeroFill((colNum * 4) + row, 2)
					//	)	
					//)
					//.map((row, rowIdx) => 
					//	row.map((groupComma, groupIdx) => {
					//		const firstPercent = singleGame ? 30 : 30.5;
					//		const leftSpace = singleGame ? 116 : 34;
					//		const width = singleGame ? "8px" : "8px";

					//		return <div key={"p6_n2_1_" + rowIdx + "_" + groupIdx}
					//			className={"sl-bet hidden sl-green-old"}
					//			style={{position: "absolute",
					//					left: "calc(" + firstPercent + "% + " + (groupIdx * leftSpace) + "px)",
					//					top: "calc(17% + " + (rowIdx * 33) + "px)",
					//					background: "transparent",
					//					width: width,
					//					height: "28px"}}>
					//			<Chips between={true} {...commonChipProps} betKey={groupComma + "+n2"} />
					//			<Tooltip {...commonTooltipProps} bet={this.props.bets[groupComma + "+n2"]} />
					//			<div className="sl-hover-hidden"
					//			{...{
					//				bet: groupComma,
					//				group: "n2",
					//				...pcodeProp
					//			}}
					//				// bet={groupComma} pcode={this.props.pcode} group="n2"
					//				onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
					//		</div>;
					//	})
					//)
				}

				<MultibetGenerator
					keyPattern={
						nary(4).map(row =>
							nary(5).map(colNum =>
								zeroFill((colNum - 1) * 4 + row, 2) +
								"," +
								zeroFill((colNum * 4) + row, 2)
							)	
						)
					}

					langdata={langdata}

					firstLeftPercent={singleGame ? 30.5 : 31}
					firstTopPercent={25}

					leftSpace={singleGame ? "116px" : "34px"}
					topSpace={"33px"}

					width={8}
					height={28}

					betGroup="n2"

					{... commonMultiBetProps}
				/>

				{
					[
					["01,02", "05,06", "09,10", "13,14", "17,18", "21,22"],
					["02,03", "06,07", "10,11", "14,15", "18,19", "22,23"],
					["03,04", "07,08", "11,12", "15,16", "19,20", "23,24"]
					].map((row, rowIdx) => 
						row.map((groupComma, groupIdx) => {
							const firstPercent = singleGame ? 21.5 : 22;
							const leftSpace = singleGame ? 116 : 34;
							const width = singleGame ? "100px" : "28px";

							return <div key={"p6_n2_2_" + rowIdx + "_" + groupIdx}
								className={"sl-bet hidden sl-green-old"}
								style={{position: "absolute",
										left: "calc(" + firstPercent + "% + " + (groupIdx * leftSpace) + "px)",
										top: "calc(31% + " + (rowIdx * 33) + "px)",
										background: "transparent",
										width: width,
										height: "8px"}}>
								<Chips between={true} {...commonChipProps} betKey={groupComma + "+n2"} />
								<Tooltip {...commonTooltipProps} bet={this.props.bets[groupComma + "+n2"]} />
								<div className="sl-hover-hidden"

								{...{
									bet: groupComma,
									group: "n2",
									...pcodeProp
								}}

									onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
							</div>;
						})
					)
				}

				{
					[
					["01,02,05,06", "05,06,09,10", "09,10,13,14", "13,14,17,18", "17,18,21,22"],
					["02,03,06,07", "06,07,10,11", "10,11,14,15", "14,15,18,19", "18,19,22,23"],
					["03,04,07,08", "07,08,11,12", "11,12,15,16", "15,16,19,20", "19,20,23,24"]
					].map((row, rowIdx) => 
						row.map((groupComma, groupIdx) => {
							const firstPercent = singleGame ? 30 : 30.5;
							const leftSpace = singleGame ? 116 : 34;
							const width = singleGame ? "8px" : "8px";

							return <div key={"p6_n4_3_" + rowIdx + "_" + groupIdx}
								className={"sl-bet hidden sl-green-old"}
								style={{position: "absolute",
										left: "calc(" + firstPercent + "% + " + (groupIdx * leftSpace) + "px)",
										top: "calc(27% + " + (rowIdx * 33) + "px)",
										background: "transparent",
										// background: "rgba(0,255,255,0.5)",
										width: width,
										height: "24px"}}>
								<Chips between={true} {...commonChipProps} betKey={groupComma + "+n4"} />
								<Tooltip {...commonTooltipProps} bet={this.props.bets[groupComma + "+n4"]} />
								<div className="sl-hover-hidden"
								{...{
									bet: groupComma,
									group: "n4",
									...pcodeProp
								}}
									onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
							</div>;
						})
					)
				}
			</div>
		)
		);
	}
}
